<template>
  <div>
  
    
    <b-row >
       
  <!----- SideBar All Design List ---->
  <div class="reportside">
     <sidebarAllDesignsComponent></sidebarAllDesignsComponent>
  </div>
  <!----- SideBar All Design List End ----> 
  
     <div class="design-container-details__main" >
        <div class="brand-card" >

          <div class="col-md-12" style="margin-top:10px;margin-bottom:10px;">
             <div class="col-md-12">Design Title:<strong> &nbsp;{{style_details.design_title}}</strong> </div>
              <div class="col-md-12">Style Name : &nbsp;{{style_details.style_name}} >> {{style_details.sub_cattitle}}</div>
              <div class="col-md-12">Created Date : {{style_details.created_date }} </div>
              <div class="col-md-12">Buyer Name : {{style_details.sendqname }} </div>
          </div>

<!-- Code For Tab -->
<navbarMenu></navbarMenu>
<br>

<!-- Code For Tab Ends -->
                      <!-- <b-col sm="12"> -->
        <!-- <b-card> -->
            <b-col sm="12">
                <label><b>Vendor Name &nbsp;:</b> {{selectedvendorname}}</label>&nbsp;&nbsp;&nbsp;&nbsp;
              
                <label><b>Buyer Name&nbsp;:</b> {{selectedbuyername}}</label>&nbsp;&nbsp;&nbsp;&nbsp;
              
                <label><b>Status&nbsp;:</b> {{selectedstatus}}</label>&nbsp;&nbsp;&nbsp;&nbsp;
             </b-col>


               <ul class="nav nav-tabs">
            <li class="nav-item">
              <router-link :to="'/design_purchaseorder/' + route_id" class="nav-link " data-toggle="pill">
               Purchase Order 
            
            </router-link>
            </li>
            <!-- <li class="nav-item">
              <router-link :to="'/fcplm_vendor/poform/' " class="nav-link " data-toggle="pill">
              Po form 
            
            </router-link>
            </li> -->
             <li class="nav-item" v-if="user_type!='Quality_Executive'" >
             <router-link :to="'/design_po_tna/'+ route_id " class="nav-link " data-toggle="pill">
              TNA   
            
            </router-link>
            </li>
            <li class="nav-item" v-if="user_type=='Quality_Executive'" >
             <router-link :to="'/qc_executive_tna/'+ route_id " class="nav-link " data-toggle="pill">
              TNA   
            
            </router-link>
            </li>
            <li class="nav-item">
             <router-link :to="'/design_po_reports/'+ route_id " class="nav-link " data-toggle="pill">
              Reports   
            
            </router-link>
            </li>
           
             
          </ul>  
          <br><br>    
              <!-- For other user ends -->
<!-- <div class="col-md-12">
  <div class="col-md-12"> -->
              <b-col md="12" >
              <label style="float: left;"><b>PO Reports Details</b></label>    
              <!-- <b-button type="button" style="float: right;" variant="primary" size="md" v-b-modal.RequestProtoSamplemodel>Request Sample</b-button> -->
              </b-col><br>
       <!-- <b-col sm="12"> -->

          
          <b-table class="mt-4 poreporttable" show-empty stacked="md"   :items="report_list"  :fields="fields1" :bordered="bordered">
            <div slot="table-busy" class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>
              <!-- <template slot="table-caption"><b>Proto sample</b></template> -->
              <template slot="action" slot-scope="row">

                  <div v-if="row.item.status=='approved' || row.item.status=='Approved' || row.item.status=='Actual_Approved' || row.item.status=='Actual_Reject' || row.item.status=='rejected' || row.item.status=='Actual_PartialApproved'">
                  <label v-if="row.item.status=='approved'|| row.item.status=='Actual_Approved' || row.item.status=='Approved'">
                    <i class="fa fa-check" aria-hidden="true" style="color: #2ECC71">&nbsp;Approved</i>
                  </label>
                  <label v-if="row.item.status=='Actual_Reject' || row.item.status=='rejected'">
                    <i class="fa fa-close" aria-hidden="true" style="color: #E74C3C">&nbsp;Rejected</i>
                  </label>


                  <label v-if="row.item.status=='Actual_PartialApproved'">
                    <i class="fa fa-check" aria-hidden="true" style="color: #1082F3">&nbsp;Partially Approved</i>
                  </label>
                </div>
                        <!-- <b-col md="12" class="pull-right text-right"> -->

                          <div v-if="(row.item.activities=='FPT Submission' || row.item.activities=='PP Sample Submission' || row.item.activities=='GPT Sample Submission') && row.item.status=='Submitted' && (selected_operational_status!='TNA–uploaded' && selected_operational_status!='TNA_Feedback' && selected_operational_status!='TNA-Rejected') && user_type!='Quality_Controller' && user_type!='Quality_Executive'">
                  <label class="radio-inline" ><input type="radio" name="tnaoptradio" value="tnaapproved" v-model="status" checked @click="achivedtnaaction('tnaapproved',row.item.tna_id,row.item.activities_id)" >&nbsp;Approve</label>&nbsp;&nbsp;

                   <label class="radio-inline"  v-if="row.item.activities!='Final Inspection'"><input type="radio" name="tnaoptradio" value="conditionalapproved" v-model="status" @click="achivedtnaaction('conditionalapproved',row.item.tna_id,row.item.activities_id)" >&nbsp;Partially Approve</label>&nbsp;&nbsp;

                  <label class="radio-inline" ><input type="radio" name="tnaoptradio" value="tnarejected" v-model="status" @click="achivedtnaaction('tnarejected',row.item.tna_id,row.item.activities_id)" >&nbsp;Reject</label>
                </div>
                <div v-if="(row.item.activities=='Final Inspection') && row.item.status=='Submitted' && (selected_operational_status!='TNA–uploaded' && selected_operational_status!='TNA_Feedback' && selected_operational_status!='TNA-Rejected') && user_type=='Quality_Controller' && user_type!='Quality_Executive'">
                  <label class="radio-inline" ><input type="radio" name="tnaoptradio" value="tnaapproved" v-model="status" checked @click="achivedtnaaction('tnaapproved',row.item.tna_id,row.item.activities_id)" >&nbsp;Approve</label>&nbsp;&nbsp;

                   <label class="radio-inline" v-if="row.item.activities!='Final Inspection'"><input type="radio" name="tnaoptradio" value="conditionalapproved" v-model="status" @click="achivedtnaaction('conditionalapproved',row.item.tna_id,row.item.activities_id)" >&nbsp;Partially Approve</label>&nbsp;&nbsp;

                  <label class="radio-inline" ><input type="radio" name="tnaoptradio" value="tnarejected" v-model="status" @click="achivedtnaaction('tnarejected',row.item.tna_id,row.item.activities_id)" >&nbsp;Reject</label>
                </div>
                        <!-- <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret >
                          <template v-slot:button-content>
                            <button @click="getrowdata(row.item)" style="border: none;" ><span class="cui-options icons font-1xl d-block" style="font-size: 20px;"></span></button>
                          </template>
                        </b-dropdown> -->
                        <!-- </b-col> -->
                    </template> 

          </b-table>
          
         <!-- </b-col> -->
</div>
            <!-- </div>
        </div> -->

</div>



 </b-row>    



   </div>


 
</template>

<script>

   import CONSTANTS from '@/utils/constants'
   import auth from '@/utils/auth'
   import Vue from 'vue'
   import Router from 'vue-router'
   import Utils from "@/utils";
   import swal from "sweetalert2";

   import sidebarAllDesignsComponent from './_sidebarAllDesignsComponent.vue'
   import navbarMenu from './_navbarMenu.vue'
   
   const axios = require('axios')
   export default {
     name: 'Tabs',
     components: {
        sidebarAllDesignsComponent,
        navbarMenu
      },  

     data () {
       return {
         addfile:false,
         showSideMenu:true,
         items2: [{
          'buyer_name': 'S_Test_Buyer'
         }],
         result: [],
         style_details:[],
         totalRows: 0,
         outlined:true,
         bordered: true,
         fields1: [
               {key: 'activities', label: 'Activity Name'}, 
               {key: 'planned_achieve_date',label:'Planned Achieved Date'},
               {key: 'actual_achieved_date',label:'Actual Achieved Date'}, 
               {key:'status' , label:'Status' },
               {key:'action' , label:'Action'}
              ],

         file_tab_status: false,
         fileupload_status: false,
         fileObj:[],
         result: [],
         status: '',
         route_id: '',
         selected_vendor_id: 0,
         report_list: [],
         selectedbuyername: '',
         selectedvendorname:'',
         selectedstatus: '',
         selected_operational_status: '',
        }  
     },
     created: function() { 
      this.getdesigndetail();
      this.route_id=this.$route.params.id;
      var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData);
      this.user_type = userInfo[0].user_type;
      // this.getreportlisting();
      var userData = localStorage.getItem('userData');
      if(userData) 
      {
        this.quote_tab=true;
        this.message_tab=true;
      }


     },
       methods: {  

        getrowdata: function(value){

        },

       /****** Function to design details ********/
       getdesigndetail: function () {
           this.isBusy = true;
       
           const Obj = {
                style_id: this.$route.params.id,              
              }
           axios.post(`${CONSTANTS.API_URL}/getdesigndetail`,Obj)
           .then(response => {
            document.getElementById("overlay").style.display = "none";

             this.result = response.data
             if (this.result.returnmsg === 'Successful') {
              
            this.style_details  = this.result.returnvalue[0];
            this.selected_vendor_id= this.style_details.vendor_id;
             this.selected_operational_status= this.style_details.operational_status;
            // alert(this.selected_vendor_id)
            this.selectedvendorname = this.style_details.vendor_name;
            this.selectedbuyername = this.style_details.sendqname;
            this.selectedstatus = this.style_details.design_status;
            this.totalRows = this.result.returnvalue.length;
            for(var i=0;i<=this.totalRows;i++){
              if(this.style_details.status_code_number>=8){
                this.file_tab_status =true;
                
              }
            }
            this.getreportlisting();
           
            }

           })
           // .catch(e => {
           //   this.errors.push(e)
           // })
   
   
       },
               //Function for TNA action
        achivedtnaaction: function(status,tna_id,activities_id){
          // alert("In");
          // alert(status);
          this.selected_status=status;
          this.selected_tna_id=tna_id;
          this.selected_activities_id=activities_id;
          var userdata = localStorage.getItem('userData')
          var userInfo = JSON.parse(userdata)

          // if(confirm("Are you sure you want to "+status+"?")){  
            const Obj={
            tna_status: status,
            tna_id: tna_id,
            activities_id: activities_id,
            style_id: this.$route.params.id,
            updated_by: userInfo[0].email_id
          }
          // alert(tna_id);

           

          axios.post(`${CONSTANTS.API_URL}/achivedTNADetailStatus`,Obj)
          .then((result) => {
            document.getElementById("overlay").style.display = "none";
            console.log("SSSSSSSSSSS",result);  
            if(result.data.returnmsg=='Successful'){
              // alert("TNA updated Sucessfully");
              this.$fire({
                      text:" TNA updated Sucessfully.",
                      type: "success",
                      timer: 30000
                            })
              // this.tnadetails();
              this.getdesigndetail();
              
              // this.tnadetails();
              // this.getdesigndetail();
            }      
            else{
              // alert(result.body.returnmsg);
              this.$fire({
                      text:result.body.returnmsg,
                      type: "error",
                      timer: 30000
                            })
              this.tna_archivedaction_status = "nochanged";
            }
          })
          .catch((ex) => {
            console.log('error', ex)
          })
          //}
         
          
        },
        //Function for TNA action ends
           
        deletefile: function(id){
         // document.getElementById("overlay").style.display = "block";
          if(confirm("Do you really want to delete?")){
            const Obj = {
                id: id 
              }
          axios.post(`${CONSTANTS.API_URL}/deletedesignfile `,Obj)
           .then(response => {
            document.getElementById("overlay").style.display = "none";
             this.result = response.data;
             if (this.result.returnmsg === 'Successful') {
              // Utils.notify("File Deleted Successfully", "success"); 
               this.$fire({
                      text:" File Deleted Successfully.",
                      type: "success",
                      timer: 30000
                            })
              this.getfileslisting(); 
             }else {
              // alert("Please Select Proper File")
               this.$fire({
                      text:" Please Select Proper File.",
                      type: "warning",
                      timer: 30000
                            })
             }
           })
           .catch(e => {
             this.errors.push(e)
           })
          }

        },
        //Code For Delete File Ends
        onClose() {
            this.visible = false;
        },


        /****** Function to design summary ********/
       getreportlisting: function () {
          document.getElementById("overlay").style.display = "block";
           this.isBusy = true;
           const Obj = {
                style_id:  this.$route.params.id,
                vendor_id:this.selected_vendor_id
              }
          
           axios.post(`${CONSTANTS.API_URL}/getTNAReports`,Obj)
           .then(response => {
            document.getElementById("overlay").style.display = "none";
             this.result = response.data
             if (this.result.returnmsg === 'Successful') {
   
               this.report_list = this.result.returnvalue;
               this.totalRows = this.result.returnvalue.length;
   
               
               this.isBusy = !this.isBusy;
               
             }else {
              this.report_list =[];
              this.totalRows=0;
                this.isBusy = !this.isBusy;
             }
   
   
           })
           .catch(e => {
             this.errors.push(e)
           })
   
   
       },


    /****** Function to Add Files********/
    validateForm(scope) {
    
      this.$validator.validateAll(scope).then(result => {
        if (result) {         
          this.addDesignFiles(scope);
        }
      });
    },
    addDesignFiles() {
     document.getElementById("overlay").style.display = "block";
        this.id = this.$route.params.id;

        var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData);
      if (this.file_category != '' || this.file_category!=null || this.file_category!= undefined) 
           {
            let data = new FormData();
            let file = event.target.files[0];
            this.imgname= file.name;
            data.append('file', file)
            data.append('style_id',this.id)
            data.append('file_name',this.imgname)
            data.append('category_name',this.file_category)
            data.append('created_by',userInfo[0].email_id)
            data.append('uploaded_by',userInfo[0].email_id)
            data.append('user_id',userInfo[0].user_id)

                let config = {
                  header : {
                   'Content-Type' : 'multipart/form-data'
                 }
                }

              axios.post(`${CONSTANTS.API_URL}/uploaddesignfiles`,data, config)
              .then(response => {
                document.getElementById("overlay").style.display = "none";
                  if(response.data.returnmsg == 'Successful') {
                      
                      // alert(" File Added Successfully.");
                      this.$fire({
                      text:" File Added Successfully.",
                      type: "success",
                      timer: 30000
                            })
                      this.uploadfilemodel=false;
                      this.getfileslisting();
                             

                  } else {
                    if (result.body.returnmsg === 'NoUserExists') {

                      this.showAlert=true
                      
                    }
                  }
              })
          }
          else{
            // alert("Please Select File Type");
             this.$fire({
                      text:" Please Select File Type.",
                      type: "warning",
                      timer: 30000
                            })
          }
        
      
    },


        onClose() {
            this.visible = false;
        },

     }
   };
</script>
<style>
   .short-div {
   height:55px;
   }


.quote-dropdowns .dropdown--accepted {
    border-top: 1px solid var(--fill-green-dark);
}

.quote-dropdowns>.card {
    background-color: var(--fill-white);
}
.quote-dropdowns .dropdown__header.dropdown__header--accepted {
    border: 1px solid var(--fill-green-dark);
    border-top: none;
    background-color: #e8fff5;
}
.card .card__section {
    flex-grow: 1;
    box-shadow: inset 0 -1px 0 0 #e5e5e5;
    box-shadow: inset 0 -1px 0 0 var(--fill-grey-light3);
}
.quote-dropdowns .dropdown__header {
    align-items: center;
    justify-items: center;
    justify-content: center;
    cursor: pointer;
}
.quote-dropdowns .card__section {
    padding: 16px 32px;
}
.f-sz-l {
    font-size: 15px;
}
.flex-col {
    flex-direction: column;
}
.flex, .flex-col {
    display: flex;
}
.f-w-semi-bold {
    font-weight: 600;
}
.f-sz-sm {
    font-size: 12px;
}
.f-w-semi-bold {
    font-weight: 600;
}   

.card .card__section {
    flex-grow: 1;
    box-shadow: inset 0 -1px 0 0 #e5e5e5;
    box-shadow: inset 0 -1px 0 0 var(--fill-grey-light3);
}
.quote-dropdowns .card__section {
    padding: 16px 32px;
}

.input-grp {
    width: 100%;
    margin-bottom: 16px;
}
.input-grp {
    margin-bottom: 10px!important;
}

.input-grp label {
    margin-bottom: 6px;
    color: #333340;
}

input[type=number], input[type=password], input[type=tel], input[type=text] {
    padding: 13px 12px;
    border-radius: 2px;
    border: 1px solid #bfbfbf;
}
.input-grp input, .input-grp label, .input-grp select {
    display: block;
    width: 100%;
}

.input-grp select:disabled {
    background-color: #ebebe4;
}
.input-grp select {
    background: url(/static/media/ic-arrow-drop-down.1f6abe65.svg) no-repeat;
    background-position: right 8px top 6px;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
}

.quote-dropdowns .dropdown__header.dropdown__header--accepted {
    border: 1px solid var(--fill-green-dark);
    border-top: none;
    background-color: #e8fff5;
}

  
    .main_body1{
      width: 970px;
    }
   /*.card-footer{
    border-radius: 0 0 15px 15px !important;
      border-top: 0 !important;
      background-color: #F5F5F5 !important;

  }*/
    .container{
      align-content: center;
    }
    .search{
      border-radius: 15px 0 0 15px !important;
      background-color: white !important;
      border:0 !important;
      color:white !important;
    }
    .search:focus{
         box-shadow:none !important;
          outline:0px !important;
    }
    /*.type_msg{
      background-color: white !important;
      border:0 !important;
      color:white !important;
      height: 60px !important;
      overflow-y: auto;
    }*/
      #type_msg:focus{
         box-shadow:none !important;
           outline:0px !important;
    }
    .send_btn{
      border:1 !important;
      border-color: #20a8d8;
      background-color: #4d94ff;
      cursor: pointer;
    }
    .search_btn{
      border-radius: #20a8d8 !important;
      border:0 !important;
      background-color: #20a8d8;
      cursor: pointer;
    }
    .contacts{
      list-style: none;
      padding: 0;
    }
    .contacts li{
      width: 100% !important;
      padding: 5px 10px;
      margin-bottom: 15px !important;
    }

    .user_img{
      height: 40px;
      width: 30px;
      border:1.5px solid #f5f6fa;
      margin-left: 10px;

    }
    .user_img_msg{
      height: 30px;
      width: 30px;
      border:1.5px solid #f5f6fa;
    
    }
  .text-span{
    background:blue;
    border-radius:50%;
    height: 26px;
    width: 26px;
    line-height: 26px;
    display: inline-block;
    text-align: center;
    margin-right: 6px;
}
.text-span2{
    background:gray;
    border-radius:50%;
    height: 26px;
    width: 26px;
    line-height: 26px;
    display: inline-block;
    text-align: center;
    margin-right: 6px;
}

  .brand-card{
   border-radius:0px !important;
  }

     .sidebar{
   background: #17a2b8!important;
   width:50px !important;
   }

   .sidebar .sidebar-nav{
    width:50px !important;
   }
   .sidebar .nav{
    width:50px !important;
   }

   .main{
    margin-left:50px !important;
   }
   #rec_msg{    
    margin-left: 40%;
    position: absolute;
   }


/*** Tabb ***/
.header-tabs__navbar {
    margin-top: auto;
    align-items: center;
    border-top: 1px solid var(--fill-grey-light2);
}
.flex {
    display: flex;
}

.header-tabs__tab {
    position: relative;
    flex: 1 1;
    height: 43px !important;
    padding: 12px 22px;
    border-bottom: 3px solid var(--fill-grey-light3);
    display: flex;
    flex-direction: row;
    cursor: pointer;
    border: 1px solid #63c2de;
    border-radius: 12px;
}

.header-tabs__tab-image {
    padding-right: 8px;
}

.header-tabs__tab-block {
    display: flex;
    flex-direction: column;
    justify-content: center;
}
 
.header-tabs__tab .sub_title {
    font-size: 12px;
    line-height: 16px;
    text-transform: capitalize;
    font-weight: 400;
    color: var(--fill-grey-medium);
} 



html, body {
  margin: 0
}
.wrapper {
  display: flex;
  flex-direction: column;
  height: 92vh;
  width: 100%;
  background-color:white
}

/*Todays CSS*/
.nav_row_tabs {
 
  display: flex;
  border-top: 1px solid #D7DBDD;
  border-bottom: 1px solid #D7DBDD;
}


  #activeTitle{
  font-size: 14px;
}
.poreporttable{
  width: 95% !important;
}
.report_action{

}
@media (max-width: 500px)
{
 .poreporttable{
  width: 90% !important;
}
}
@media (max-width: 1040px)
{
 .reportside{
  display:none;
 }
}
</style>
